import styled from 'styled-components';
import { EmptyStateEnvelope } from 'ui/illustrations';

import { useListUsageQueryContext } from '../contexts/ListUsageQueryContext';
import { ORDERED_TABLE_COLUMNS } from './constants';
import { useTranslation } from '../../hooks';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  grid-column: 1 / span ${ORDERED_TABLE_COLUMNS.length};
  row-gap: ${({ theme }) => theme.spacing.values.half};
  height: ${({ theme }) => theme.spacing.values.x32};
`;

const Title = styled.div`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textColors.textPrimary};
  font-size: 20px;
`;

const Subtitle = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
  width: ${({ theme }) => theme.spacing.values.x32};
  text-align: center;
`;

export const EmptyState = () => {
  const { t } = useTranslation();
  const { isError } = useListUsageQueryContext();

  return (
    <Wrapper data-test="empty-state">
      <EmptyStateEnvelope />
      <Title>{t('insights.listUsage.emptyTitle')}</Title>
      <Subtitle>
        {t(isError ? 'insights.listUsage.errorSubtitle' : 'insights.listUsage.emptySubtitle')}
      </Subtitle>
    </Wrapper>
  );
};
